import PythonCompiler from './PythonCompiler';
export default PythonCompiler;
